// extracted by mini-css-extract-plugin
export default {"promo":"styles_promo__rjpBE","promo__title":"styles_promo__title__03+Ex","promo__item":"styles_promo__item__LA-oU","promo__code":"styles_promo__code__6yw6v"};